<template>
    <div>
        <work-status-header :page-name="headerText"></work-status-header>
        <div v-if="getWorkStatus.data">
            <div v-if="getWorkStatus.data.length">
                <work-status-input></work-status-input>
                <work-status-list v-show="show"></work-status-list>
            </div>
            <!-- 0件メッセージ -->
            <not-found-msg v-else></not-found-msg>
        </div>

        <!-- メニュー -->
        <work-menu ref="menu"></work-menu>
        <!-- 個人情報 -->
        <private-info ref="privateInfo"></private-info>
        <!-- 契約期間 -->
        <contract-period ref="contract" opt="1"></contract-period>
        <!-- 退場確定 -->
        <exit-confirm ref="exitConfirm"></exit-confirm>
        <!-- メッセージ -->
        <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOk"></info-msg>

    </div>
</template>

<script>
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    import WorkStatusHeader from 'pages/commons/header/Header'
    import WorkStatusInput from './components/Input'
    import WorkStatusList from './components/List'

    import workMenu from './components/Menu'
    import PrivateInfo from 'pages/commons/modal/privateInfo/PrivateInfo'
    import ContractPeriod from 'pages/commons/modal/contractPeriod/ContractPeriod'
    import ExitConfirm from './components/ExitConfirm'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'

    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                show: true,
                lev: 0,
                msg: "",
                item: {},
                msgKey: ""
            }
        },
        components: {
            WorkStatusHeader,
            WorkStatusInput,
            WorkStatusList,
            NotFoundMsg,
            workMenu,
            PrivateInfo,
            ContractPeriod,
            ExitConfirm,
            InfoMsg
        },
        created () {
            this.loadWorkStatus()
        },
        destroyed () {
            this.$store.dispatch('resetWorkStatus')
        },
        watch: {
            getWorkStatusLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            headerText () {
                if (this.$route.params.do == 'working') {
                    return '現場中(余裕)'
                }
                if (this.$route.params.do == 'updateWait') {
                    return '更新待ち'
                }
                if (this.$route.params.do == 'exitWait') {
                    return '退場待ち'
                }
                if (this.$route.params.do == 'exited') {
                    return '退場済み'
                }
                if (this.$route.params.do == 'delete') {
                    return '削除待ちの案件'
                }
                if (this.$route.params.do == 'accesslimit') {
                    return '閲覧制限'
                }
                return ""
            },
            ...mapGetters(['getWorkStatusLoadStatus', 'getWorkStatus'])
        },
        methods: {
            loadWorkStatus () {
                this.$store.dispatch('loadWorkStatus', {
                    do: this.$route.params.do
                })
            },
            openPrivateInfo (userId) {
                this.$refs.privateInfo.openThis(userId)
            },
            openContractPeriod (item) {
                this.$refs.contract.openThis(item)
            },
            openExitConfirm (item) {
                this.$refs.exitConfirm.openThis(item)
            },
            openMsg (lev, msg, key="", item) {
                this.lev = lev
                this.msg = msg
                this.msgKey = key
                this.item = item
                this.$refs.msg.openThis()
            },
            msgOk () {
                if (this.msgKey == 'changeToExited') {
                    this.$store.dispatch('changeToExited', {
                        applyId: this.item.ai_id,
                        intvId: this.item.id
                    })
                }
            },
            showWorkList () {
                this.show = true
            },
            hideWorkList () {
                this.show = false
            },
        }
    }
</script>

<style></style>
